import React, { Suspense } from "react";
import {
  Route,
  Navigate,
  createRoutesFromElements,
  createHashRouter,
  RouterProvider,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./services/useAuth";
import ThemeProvider from "./contexts/theme";
import Loading from "./components/CustomUI/Loading";
import Login from "./views/auth/Login";

// Lazy load layout
const DefaultLayout = React.lazy(() => import("./layout/Default"));

const ProtectedRoute = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <Loading fullScreen={true} text="Oturum doğrulanıyor..." />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <DefaultLayout />;
};

const PublicRoute = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <Loading fullScreen={true} text="Oturum doğrulanıyor..." />;
  }

  if (user) {
    return <Navigate to="/" replace />;
  }

  return <Login />;
};

const router = createHashRouter(
  createRoutesFromElements(
    <Route>
      <Route path="/login" element={<PublicRoute />} />
      <Route path="/*" element={<ProtectedRoute />} />
    </Route>,
  ),
  {
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    },
  },
);

const App = () => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Suspense fallback={<Loading fullScreen={true} />}>
          <RouterProvider router={router} />
        </Suspense>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
